module.exports = __webpack_public_path__ + "static/Inventory-Optimization-Retail-4f35ab2b80e53818218e99e1099d260f.jpg";